import { plainToClass } from "class-transformer";
import { UserListingDto } from "./settings.objects";
import { TableColumnVisibilityController, TableColumnGroup } from "../../../shared/scripts/table-column-visibility";
import { Unique } from "../../../shared/scripts/array-functions";
import { IFilter } from "../../../shared/scripts/filtering/filtering.entities";
import { InitializeFilterDropdown } from "../../../shared/scripts/filtering/filtering.utilities";
import { SettingsPicklists } from "./scripts/settings.picklists";

export class SettingsPage implements IFilter {
    users: UserListingDto[];
    dataTable: any;
    filterDropdownIds: string[];
    token: string;
    roles: any[];
    allAppUsers: any[];
    portalUsersTable: any;
    selectedAppUserData: any = null;
    picklists: SettingsPicklists;
    selectedUsers: { [id: string]: any } = {};
    isNonViewer: boolean;
    isAdmin: boolean;
    archiveUserId: number = null;

    constructor(
        allUsersJson: any,
        allRolesJson: any,
        allAppUsersJson: any,
        actionItemCriticalTypesJson: any,
        actionItemStatusesJson: any,
        actionItemTypesJson: any,
        attachmentTypesJson: any,
        communicationStatusesJson: any,
        communicationTopicsJson: any,
        communicationTypesJson: any,
        jobFunctionsJson: any,
        deliverablesJson: any,
        milestonesJson: any,
        addressTypesJson: any,
        deliverableStatusesJson: any,
        studyStatusesJson: any,
        isNonViewer: boolean,
        isAdmin: boolean
    ) {
        $(() => {
            this.isNonViewer = isNonViewer === true;
            this.isAdmin = isAdmin === true;
            this.users = plainToClass(UserListingDto, <UserListingDto[]>allUsersJson);
            this.roles = allRolesJson;
            this.allAppUsers = allAppUsersJson;
            this.filterDropdownIds = ["#role-dropdown"];
            this.token = document.querySelector('input[name="__RequestVerificationToken"]').getAttribute('value');
            this.initializeFilters(allRolesJson);
            this.initializeTable();
            this.initializeModal();
            this.initializeArchiveModal();
            // Initialize picklists logic and pass all picklist data
            this.picklists = new SettingsPicklists({
                actionItemCriticalTypes: actionItemCriticalTypesJson,
                actionItemStatuses: actionItemStatusesJson,
                actionItemTypes: actionItemTypesJson,
                attachmentTypes: attachmentTypesJson,
                communicationStatuses: communicationStatusesJson,
                communicationTopics: communicationTopicsJson,
                communicationTypes: communicationTypesJson,
                jobFunctions: jobFunctionsJson,
                deliverables: deliverablesJson,
                milestones: milestonesJson,
                addressTypes: addressTypesJson,
                deliverableStatuses: deliverableStatusesJson,
                studyStatuses: studyStatusesJson
            }, isNonViewer, isAdmin);
            $('#newUserDialog').on('hidden.bs.modal', () => {
                const validationError = document.getElementById('validation-error');
                validationError.classList.add('d-none');
            });
            $('#newUserDialog').on('shown.bs.modal', () => {
                this.selectedAppUserData = null;
                this.selectedUsers = {};
            });
        });
    }

    initializeFilters(allRolesJson: any): void {
        let roleValues: string[] = this.users.map(c => c.RoleName);
        InitializeFilterDropdown('#role-dropdown', Unique(roleValues, true, ["None Selected"]), this);
    }

    initializeTable(): void {
        const self = this;
        this.dataTable = $('#users-table').DataTable({
            dom: 'rtip',
            autoWidth: false,
            info: false,
            paging: false,
            search: true,
            scrollX: true,
            scrollY: '60vh',
            scrollCollapse: true,
            orderCellsTop: true,
            order: [[0, 'asc']],
            columns: [
                { data: "Name", title: "Name" },
                { data: "Email", title: "Email" },
                { data: "RoleName", title: "Role" },
                {
                    data: null,
                    title: "",
                    className: "ctms-table-col-actions",
                    orderable: false,
                    render: function (data, type, row) {
                        let html = `<a href="/secure/ctms/settings/user-details?id=${row.Id}" title="Edit"><i class="ctms-icon-pencil"></i></a>`;
                        if (self.isAdmin) {
                            html += ` <button class="archive-user-btn ml-2" data-id="${row.Id}" data-name="${row.Name}" title="Archive"><i class="ctms-icon-close"></i></button>`;
                        }
                        return html;
                    }
                }
            ],
            data: this.users
        });

        $('#custom-dt-search').on('input', function () {
            $('#users-table').DataTable().search(String($(this).val() ?? '')).draw();
        });
        $('.ctms-icon-button[title="Clear Search"]').on('click', function () {
            $('#custom-dt-search').val('');
            $('#users-table').DataTable().search('').draw();
        });

        $('#users-table tbody').on('click', '.archive-user-btn', (e) => {
            const $btn = $(e.currentTarget);
            this.archiveUserId = parseInt($btn.data('id'), 10);
            $('#archiveUserName').text($btn.data('name'));
            $('#archiveUserModal').modal('show');
        });
    }

    updateTable(matchingItems: UserListingDto[]): void {
        this.dataTable.clear();
        this.dataTable.rows.add(matchingItems).draw();
    }

    triggerFilter(): void {
        const selectedRole = this.getSelectedDropdownValues('#role-dropdown');
        const matchingUsers: UserListingDto[] = [];
        this.users.forEach(item => {
            if (item.matchesFilter(selectedRole)) {
                matchingUsers.push(item);
            }
        });
        this.updateTable(matchingUsers);
    }

    getSelectedDropdownValues(selectId: string): any {
        return $(selectId).val();
    }

    resetFilters(): void {
        this.filterDropdownIds.forEach((dropdownId: string) => {
            $(dropdownId).selectpicker('selectAll');
            $(dropdownId).selectpicker('refresh');
        });
        $('#custom-dt-search').val('');
        this.dataTable.search('').draw();
        this.updateTable(this.users);
    }

    initializeModal() {
        $('#newUserDialog').modal({
            backdrop: 'static',
            show: false,
        });
        $('#newUserDialog').on('shown.bs.modal', () => {
            this.initializeUserDialog();
        });
    }

    initializeArchiveModal() {
        $('#archiveUserModal').modal({
            backdrop: 'static',
            show: false,
        });
        $('#confirmArchiveUserBtn').on('click', () => {
            $('#confirmArchiveUserBtn').prop('disabled', true);
            $('#archiveUserSpinner').show();
            $.ajax({
                url: '/secure/ctms/settings/settings?handler=ArchiveUser',
                headers: { "RequestVerificationToken": this.token },
                type: 'POST',
                contentType: 'application/json',
                data: JSON.stringify({ Id: this.archiveUserId }),
                success: (resp) => {
                    if (resp.success) {
                        const idToRemove = this.archiveUserId;
                        this.users = this.users.filter(u => u.Id !== idToRemove);
                        $('#users-table').DataTable().rows((idx, data: any) => data.Id === idToRemove).remove().draw();
                        $('#archiveUserModal').modal('hide');
                    } else {
                        alert('Error removing user: ' + (resp.error ?? 'Unknown error.'));
                    }
                },
                error: () => {
                    alert('Error removing user.');
                },
                complete: () => {
                    $('#confirmArchiveUserBtn').prop('disabled', false);
                    $('#archiveUserSpinner').hide();
                }
            });
        });
    }

    validateForm(): boolean {
        const roleDropdown = $('#userRoleDropdown');
        const selectedRole = roleDropdown.val();
        const selectedCheckboxes = $('input[name="selectedAppUser"]:checked');
        let valid = true;
        if (!selectedRole || selectedRole === "") {
            $('#validation-error').removeClass('d-none').text('Please select a role.');
            valid = false;
        }
        else if (selectedCheckboxes.length === 0) {
            $('#validation-error').removeClass('d-none').text('Please select at least one user.');
            valid = false;
        }
        return valid;
    }

    initializeUserDialog() {
        const $roleDropdown = $('#userRoleDropdown');
        $roleDropdown.empty();
        this.roles.forEach(function (role) {
            $roleDropdown.append($('<option>', { value: role.Id, text: role.Name }));
        });

        if (this.portalUsersTable) {
            this.portalUsersTable.clear().rows.add(this.allAppUsers).draw();
        } else {
            this.portalUsersTable = $('#appUsersTable').DataTable({
                dom: 'rtip',
                autoWidth: false,
                info: false,
                paging: false,
                search: true,
                scrollX: true,
                scrollY: '40vh',
                scrollCollapse: true,
                orderCellsTop: true,
                order: [[1, 'asc']],
                columns: [
                    {
                        data: null,
                        orderable: false,
                        render: (data, type, row) => {
                            return `<input type="checkbox" name="selectedAppUser" value="${row.Id}" />`;
                        }
                    },
                    { data: "FullName", title: "Name" },
                    { data: "Email", title: "Email" },
                    { data: "PhoneNumber", title: "Phone Number" }
                ],
                data: this.allAppUsers
            });

            $('#filter-appUser-search-input').on('input', function () {
                $('#appUsersTable').DataTable().search(String($(this).val() ?? '')).draw();
            });
            $('#filter-appUser-search-clear').on('click', function () {
                $('#filter-appUser-search-input').val('');
                $('#appUsersTable').DataTable().search('').draw();
            });
        }

        $('#appUsersTable tbody').off('change', 'input[name="selectedAppUser"]').on('change', 'input[name="selectedAppUser"]', (e) => {
            const $checkbox = $(e.target);
            const rowData = this.portalUsersTable.row($checkbox.closest('tr')).data();
            if ($checkbox.is(':checked')) {
                this.selectedUsers[rowData.Id] = {
                    PortalId: rowData.Id,
                    Name: rowData.FullName,
                    Email: rowData.Email,
                    PhoneNumber: rowData.PhoneNumber
                };
            } else {
                delete this.selectedUsers[rowData.Id];
            }
        });

        $('#saveNewUserBtn').off('click').on('click', (e) => {
            if (!this.validateForm()) {
                return;
            }
            const roleId = $('#userRoleDropdown').val();
            const selectedUsersArr = Object.values(this.selectedUsers).map(u => ({ ...u, RoleId: roleId }));
            $('#saveNewUserBtn').prop('disabled', true);
            $('#saveNewUserSpinner').show();
            $.ajax({
                url: '/secure/ctms/settings/settings?handler=AddUser',
                headers: { "RequestVerificationToken": this.token },
                type: 'POST',
                contentType: 'application/json',
                data: JSON.stringify(selectedUsersArr),
                success: (resp) => {
                    resp.forEach((addedUser) => {
                        const newUser = {
                            Id: addedUser.Id,
                            Name: addedUser.Name ?? addedUser.FullName,
                            Email: addedUser.Email,
                            RoleName: addedUser.RoleName ?? $('#userRoleDropdown option:selected').text()
                        };
                        const newUserTest = plainToClass(UserListingDto, newUser);
                        this.users.push(newUserTest);
                        this.dataTable.row.add(newUserTest).draw();
                        this.allAppUsers = this.allAppUsers.filter(u => u.Id !== addedUser.PortalId);
                    });
                    this.portalUsersTable.clear().rows.add(this.allAppUsers).draw();
                    $('#newUserDialog').modal('hide');
                },
                error: function (xhr) {
                    alert('Error adding user(s).');
                },
                complete: () => {
                    $('#saveNewUserBtn').prop('disabled', false);
                    $('#saveNewUserSpinner').hide();
                }
            });
        });
    }
}
